import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/takeWhile';
import { Settings, SettingsProvider } from '../../provider/settings-service';

export function testState(fromState: string, toState: string) {
    return fromState != toState;
}

export class Circle {
    public color = 'grey';

    constructor(
        public nr: number,
        public x: number,
        public y: number,
        public r: number,
    ) {
    }

    public trigger(): void {
        this.color = 'green';
        setTimeout(() => {
            this.color = 'grey';
        }, 150);
    }
}

@Component({
    selector: 'tapcanvas',
    templateUrl: 'tap-canvas.html'
})
export class TapCanvas {
    @Output() hit: EventEmitter<Circle> = new EventEmitter();

    @ViewChild('container')
    private container: ElementRef;

    public settings: Settings;
    public canvasWidth = 165;
    public canvasHeight = 80;

    public containerHeight: number;
    public containerTransform: string;
    public visible = false;

    public circles = [
        new Circle(1, 0, 0, 12),
        new Circle(2, 38, 0, 12),
        new Circle(3, 113, 0, 12),
        new Circle(4, 66, 18, 12),
        new Circle(5, 141, 18, 12),
        new Circle(6, 13, 38, 12),
        new Circle(7, 90, 38, 12),
        new Circle(8, 42, 56, 12),
        new Circle(9, 136, 56, 12)
    ]

    constructor(
        private settingsProvider: SettingsProvider
    ) {
        this.settings = this.settingsProvider.settings;

        // Koordinaten der Kreise sind links-oben. Mittelpunkt bilden: um Radius verschieben.
        this.circles.forEach((c) => {
            c.x += c.r;
            c.y += c.r;
        });

        this.containerTransform = this.calcTransform();

        setInterval(() => {
            const h = this.calcFullHeight();
            if (this.containerHeight != h) {
                this.containerHeight = this.calcFullHeight();
                //this.containerTransform = this.calcTransform();
                this.visible = true;
            }
        }, 100);
    }

    public circleClicked(circle: Circle): void {
        this.hit.emit(circle);
        circle.trigger();
    }

    public calcFullHeight(): number {
        if (this.container && this.container.nativeElement) {
            const hw = window.innerHeight;
            const y = this.container.nativeElement.getBoundingClientRect().top;
            return hw - y; // - 20;
        }
        return 0;
    }

    public calcTransform(): string {
        const scalex = this.settings.refsize / this.settings.realsizex;
        const scaley = this.settings.refsize / this.settings.realsizex;
        const trans = `translateX(-50%) translateY(-50%) scale(${scalex}, ${scaley})`;
        return trans;
    }
}



// WEBPACK FOOTER //
// ./src/pages/mpt/tap-canvas.ts